import React from 'react';
import { Link, useParams } from 'react-router-dom';

import { Color } from '../../../../core/enums/Color';
import { BookingLayout } from '../../types';
import { useBookingLayout } from '../../hooks';

import Icon from '../../../../components/icon/Icon';

import './LayoutSelector.scss';

const LayoutSelector: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const layout = useBookingLayout();

  return (
    <div className="layout-selector">
      <Link to={`/projects/${projectId}/bookings/calendar`}>
        <Icon icon="cards" color={layout === BookingLayout.Calendar ? Color.Black : Color.Grey} size="small" svg />
      </Link>
      <Link to={`/projects/${projectId}/bookings/list`}>
        <Icon icon="list" color={layout === BookingLayout.List ? Color.Black : Color.Grey} size="small" svg />
      </Link>
    </div>
  );
};

export default LayoutSelector;
